import { Store } from 'vuex'
import LinkItem from '~/types/LinkItem'
import loc from '~/utils/loc'
import s from '~/utils/s'

export default function mainBreadcrumbsSubmenuItems (store: Store<any>): LinkItem[] {
  return [
    {
      title: 'Каталог',
      location: loc(store, { name: 'catalog' })
    },
    {
      title: 'О компании',
      location: loc(store, { name: 'help-about' })
    },
    {
      title: 'Акции',
      location: loc(store, { name: 'stock' })
    },
    // {
    //   title: 'Контакты аптек',
    //   location: loc(store, { name: 'pharmacies' })
    // },
    {
      title: 'Новости',
      location: loc(store, { name: 'news' })
    },
    {
      title: 'Лицензия',
      location: s(store).regions.region?.code === process.env.NUXT_ENV_REGION_CODE_HAKASYA
        ? '/data/Лицензия_ЛО1902000648_от_23042020_Хакасия.pdf'
        : '/data/Лицензия_ЛО2402002248_от_16122020.pdf'
    },
    {
      title: 'Как сделать заказ',
      location: loc(store, { name: 'help-how-make-order' })
    },
    {
      title: 'Где получить заказ',
      location: loc(store, { name: 'help-how-get-order' })
    },
    {
      title: 'Доставка и оплата',
      location: loc(store, { name: 'help-delivery-payment' })
    },
    {
      title: 'Правила и условия пользования сервисом',
      location: loc(store, { name: 'help-rule-service' })
    },
    {
      title: 'Справочник заболеваний',
      location: loc(store, { name: 'diseases' })
    }
  ]
}
